import {
  AnimatedTouchable,
  OngoingParkingHeaderStyles,
} from 'components/ongoingParking/styles';
import React, { useMemo } from 'react';
import { Dimensions } from 'react-native';
import { useParkingStore } from 'stores/parkingStore';
import { isWeb } from 'utils/deviceUtils';
import { testIdentifiers } from 'utils/testIdentifiers';

type OngoingSessionHeaderContainerProps = {
  children: React.ReactNode;
  testID: string;
  onPress?: () => void;
  type: 'PARKING' | 'CHARGING';
};

const OngoingSessionHeaderContainer: React.FC<
  OngoingSessionHeaderContainerProps
> = ({ type, children, testID, onPress }) => {
  const expandModal = () => {
    useParkingStore.getState().setSelectedOngoingSession(type);
  };
  const { width } = Dimensions.get('window');

  const containerStyle = useMemo(
    () => [OngoingParkingHeaderStyles.container, isWeb ? null : { width }],
    [width]
  );

  return (
    <>
      <AnimatedTouchable
        style={containerStyle}
        onPress={onPress ? onPress : expandModal}
        {...testIdentifiers(testID)}
        accessible={false}>
        {children}
      </AnimatedTouchable>
    </>
  );
};

export default OngoingSessionHeaderContainer;
